import {GeneralExerciseComponent} from '../General/g-exercise.component';
import {clothColors} from './clothColors';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from './topic.service';
import {MessageService} from '../shared/message.service';

export abstract class GeneralClairvoyantComponent extends GeneralExerciseComponent {

  level = 1;
  counter = 0;
  solved = false;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.solved = false;
    this.isSolvedImageVisible = false;
  }

  abstract checkSolution();

  /**
   * This methode is executed each time the exercise is solved correctly
   * All values are set to their default values and the counter is incremented by one.
   */
  generateNextExercise() {
    this.counter += 1;
    this.initValues();
  }

  setTypeSpecificsFromConfiguration() {

  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  computeState() {
    this.state.counter = this.counter;
  }

  abstract setSolution (solution: any);

  setLevel(level: number) {
    this.level = level;
  }

  /**
   * Compare two arrays arr1 with arr2
   * Return true if both arrays are the same. (same length and same values in the same order)
   * @param arr1
   * @param arr2
   */
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }
}
